import {
  TREQUEST_GET_CAPACITY_BOARD,
  TRESPONSE_GET_CAPACITY_BOARD,
  TREQUEST_GET_PLANNING_BOARD,
  TRESPONSE_GET_PLANNING_BOARD,
  TRESPONSE_GET_ORDER_TIMELINE_VIEW,
  TREQUEST_GET_ORDER_TIMELINE_VIEW,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TProcessBoardsActionType } from './process-boards.models';

export class FetchCapacityBoardListing implements Action {
  readonly type = TProcessBoardsActionType.FetchCapacityBoardListing;
  constructor(public payload: TREQUEST_GET_CAPACITY_BOARD) {}
}
export class FetchCapacityBoardListingSuccess implements Action {
  readonly type = TProcessBoardsActionType.FetchCapacityBoardListingSuccess;
  constructor(public payload: TRESPONSE_GET_CAPACITY_BOARD) {}
}
export class FetchCapacityBoardListingFailure implements Action {
  readonly type = TProcessBoardsActionType.FetchCapacityBoardListingFailure;
  constructor() {}
}

export class FetchPlanningBoardListing implements Action {
  readonly type = TProcessBoardsActionType.FetchPlanningBoardListing;
  constructor(public payload: TREQUEST_GET_PLANNING_BOARD) {}
}
export class FetchPlanningBoardListingSuccess implements Action {
  readonly type = TProcessBoardsActionType.FetchPlanningBoardListingSuccess;
  constructor(public payload: TRESPONSE_GET_PLANNING_BOARD) {}
}
export class FetchPlanningBoardListingFailure implements Action {
  readonly type = TProcessBoardsActionType.FetchPlanningBoardListingFailure;
  constructor() {}
}

export class FetchOrderTimelineViewBoardListing implements Action {
  readonly type = TProcessBoardsActionType.FetchOrderTimelineViewBoardListing;
  constructor(public payload: TREQUEST_GET_ORDER_TIMELINE_VIEW) {}
}
export class FetchOrderTimelineViewBoardListingSuccess implements Action {
  readonly type = TProcessBoardsActionType.FetchOrderTimelineViewBoardListingSuccess;
  constructor(public payload: TRESPONSE_GET_ORDER_TIMELINE_VIEW) {}
}
export class FetchOrderTimelineViewBoardListingFailure implements Action {
  readonly type = TProcessBoardsActionType.FetchOrderTimelineViewBoardListingFailure;
  constructor() {}
}

export class SetSelectedProcessId implements Action {
  readonly type = TProcessBoardsActionType.SetSelectedProcessId;
  constructor(public payload: string | null) {}
}

export type TProcessBoardsActions =
  | FetchCapacityBoardListing
  | FetchCapacityBoardListingSuccess
  | FetchCapacityBoardListingFailure
  | FetchPlanningBoardListing
  | FetchPlanningBoardListingSuccess
  | FetchPlanningBoardListingFailure
  | FetchOrderTimelineViewBoardListing
  | FetchOrderTimelineViewBoardListingSuccess
  | FetchOrderTimelineViewBoardListingFailure
  | SetSelectedProcessId;
